import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext, useState } from 'react';
import { Box, Button, Flex, Grid } from '@chakra-ui/react';
import { Select } from '../../inputs';
import { Dialog } from '../../base';
import { JsFieldInspector, JsFieldName } from '../../jsFormBase';
import { JsFormConfigContext } from '../../../contexts';
import { SamplesDialog, CompositionHeader, CompositionTable, CompositionSummary } from './components';
/**
 * Component renders "/schemas/jsf-oil-blend-composition" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is an instance of TFormData.
 */
const OilBlendCompositionJsFieldFC = (props) => {
    const context = useContext(JsFormConfigContext) ?? {};
    const { samples = [], isInspector } = context;
    const [isDialog, setIsDialog] = useState(false);
    const formData = props.formData;
    const isNoSamples = formData.fieldValues.value.length === 0;
    const handleChangeFormOptionValue = (option) => {
        props.onChange({
            ...formData,
            fieldValues: {
                ...formData.fieldValues,
                optionValue: option.value
            }
        });
    };
    const handleChangeValue = (value) => {
        props.onChange({
            ...formData,
            fieldValues: {
                ...formData.fieldValues,
                value: value
            }
        });
    };
    const handleChangeSimpleValue = (index, sampleValue) => {
        const valueCopy = structuredClone(formData.fieldValues.value);
        valueCopy[index].sampleValue = sampleValue;
        handleChangeValue(valueCopy);
    };
    const handleAddSimple = (sampleId) => {
        const valueCopy = [...formData.fieldValues.value];
        valueCopy.push({ sampleId, sampleValue: null });
        handleChangeValue(valueCopy);
    };
    const handleDeleteSample = (sampleId) => {
        handleChangeValue(formData.fieldValues.value.filter((i) => i.sampleId !== sampleId));
    };
    const handleToggleDialog = () => {
        setIsDialog(!isDialog);
    };
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['object'], children: _jsx(Box, { "data-testid": "OilBlendCompositionJsField-test", "data-name": props.name, children: _jsxs(Flex, { p: "4px 0 2px 0", flexDirection: "column", gap: "8px", children: [_jsxs(Grid, { gridTemplateColumns: `184px 1fr`, alignItems: 'center', children: [_jsx(JsFieldName, { name: formData.fieldConfig.optionsTitle }), _jsx(Select, { name: props.name, options: formData.fieldConfig.options, isDisabled: props.schema.readOnly, placeholder: "\u041D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u043E", value: formData.fieldConfig.options.find((opt) => opt.value === formData.fieldValues.optionValue), onChange: (newValue) => {
                                    handleChangeFormOptionValue(newValue);
                                } })] }), _jsx(Box, { p: "4px", borderRadius: "4px", border: "1px solid", borderColor: "border", children: isNoSamples ? (_jsx(Flex, { h: "64px", alignItems: "center", justifyContent: "center", children: "\u041D\u0435\u0442 \u043F\u0440\u043E\u0431" })) : (_jsxs(Box, { children: [_jsx(CompositionHeader, {}), _jsx(CompositionTable, { value: formData.fieldValues.value, readOnly: props.schema.readOnly, suffix: props.schema.$comment, dictionary: samples, onChangeSimpleValue: handleChangeSimpleValue, onDeleteSample: handleDeleteSample }), _jsx(CompositionSummary, { suffix: props.schema.$comment, value: formData.fieldValues.value })] })) }), isDialog && (_jsx(Dialog, { title: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0440\u043E\u0431\u044B", isFloating: true, onClose: handleToggleDialog, children: _jsx(SamplesDialog, { samples: samples, selectedSamplesIdx: formData.fieldValues.value.map((i) => i.sampleId), onDeleteSample: handleDeleteSample, onAddSample: handleAddSimple }) })), !props.schema.readOnly && (_jsx(Button, { variant: "ghost", size: "smSquare", width: "100%", onClick: handleToggleDialog, children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C" }))] }) }) }));
};
export const OilBlendCompositionJsField = memo(OilBlendCompositionJsFieldFC);
//# sourceMappingURL=OilBlendCompositionJsField.js.map